/**
 * GOCE ACTIVEWEAR - Size Quantity Matrix v20
 * Broadcast theme + Customily — only on products tagged: custom-order
 */
(function () {
  'use strict';

  const DEFAULT_SIZES = ['S', 'M', 'L', 'XL', '2XL'];
  const REQUIRED_TAG = 'custom-order';

  function getSizes() {
    if (window.GOCE_PRODUCT_SIZES && window.GOCE_PRODUCT_SIZES.length) {
      return window.GOCE_PRODUCT_SIZES;
    }
    return DEFAULT_SIZES;
  }

  function isCustomOrderProduct() {
    var el = document.querySelector('[data-product-json]');
    if (!el) return false;
    try {
      var p = JSON.parse(el.textContent);
      window.__productData = p;
      var tags = Array.isArray(p.tags) ? p.tags : (p.tags || '').split(',').map(function(t){ return t.trim(); });
      return tags.includes(REQUIRED_TAG);
    } catch (e) { return false; }
  }

  function waitForElement(selector, callback, timeout) {
    timeout = timeout || 10000;
    var el = document.querySelector(selector);
    if (el) { callback(el); return; }
    var observer = new MutationObserver(function () {
      var found = document.querySelector(selector);
      if (found) { observer.disconnect(); callback(found); }
    });
    observer.observe(document.body, { childList: true, subtree: true });
    setTimeout(function () { observer.disconnect(); }, timeout);
  }

  function hideNativeUI() {
    var style = document.createElement('style');
    style.id = 'goce-hide-native';
    style.textContent = `
      quantity-counter, .quantity-selector, [data-quantity-wrapper],
      .quantity__wrapper, .product-form__quantity { display: none !important; }

      button[name="add"], button[data-add-to-cart] {
        position: absolute !important; width: 1px !important; height: 1px !important;
        padding: 0 !important; margin: -1px !important; overflow: hidden !important;
        clip: rect(0,0,0,0) !important; white-space: nowrap !important;
        border: 0 !important; opacity: 0 !important;
      }

      .shopify-payment-button, [data-shopify="payment-button"] { display: none !important; }
      .cart-bar, [data-cart-bar], .product-sticky-bar { display: none !important; }

      .goce-remove-btn {
        background: none; border: none; color: #999; font-size: 12px;
        cursor: pointer; padding: 2px 0; text-decoration: underline;
        display: block; margin-top: 4px;
      }
      .goce-remove-btn:hover { color: #c00; }
    `;
    document.head.appendChild(style);
  }

  function collapseNativeButtonsBlock(block) {
    if (!block) return;
    block.style.setProperty('padding-top', '0', 'important');
    block.style.setProperty('padding-bottom', '0', 'important');
    block.style.setProperty('margin-top', '0', 'important');
    block.style.setProperty('margin-bottom', '0', 'important');
    var submit = block.querySelector('.product__submit');
    if (submit) submit.style.setProperty('display', 'none', 'important');
  }

  function getUnitPrice() {
    var inp = document.querySelector('input[name="id"]');
    if (inp && window.__productData) {
      var found = window.__productData.variants.find(function (v) { return String(v.id) === inp.value; });
      if (found) return found.price;
    }
    return window.__productData ? window.__productData.price : 0;
  }

  function formatPrice(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function getVariantId(color, printOption) {
    var product = window.__productData;
    if (!product || !product.variants) return null;
    for (var i = 0; i < product.variants.length; i++) {
      var v = product.variants[i];
      var opts = v.options.map(function (o) { return o.toLowerCase(); });
      var okColor = !color || opts.indexOf(color.toLowerCase()) >= 0;
      var okPrint = !printOption || opts.indexOf(printOption.toLowerCase()) >= 0;
      if (okColor && okPrint && v.available) return v.id;
    }
    var first = product.variants.find(function (v) { return v.available; });
    return first ? first.id : (product.variants[0] ? product.variants[0].id : null);
  }

  function getSelectedOption(optionName) {
    var inp = document.querySelector('input[name="id"]');
    if (inp && window.__productData) {
      var found = window.__productData.variants.find(function (v) { return String(v.id) === inp.value; });
      if (found) {
        var idx = window.__productData.options.findIndex(function (o) { return o.toLowerCase() === optionName.toLowerCase(); });
        if (idx >= 0) return found.options[idx];
      }
    }
    return null;
  }

  function getSizeQuantities() {
    var result = [];
    var inputs = document.querySelectorAll('#goce-size-matrix .gsm-qty');
    for (var i = 0; i < inputs.length; i++) {
      var qty = parseInt(inputs[i].value, 10);
      var size = inputs[i].getAttribute('data-size');
      if (!isNaN(qty) && qty > 0 && size) result.push({ size: size, qty: qty });
    }
    return result;
  }

  function getTotalQty() {
    return getSizeQuantities().reduce(function(t, e) { return t + e.qty; }, 0);
  }

  function updateSummary() {
    var qty = getTotalQty();
    var unit = getUnitPrice();
    var el = document.getElementById('gsm-price-summary');
    if (!el) return;
    if (qty > 0) {
      el.innerHTML = qty + ' item' + (qty > 1 ? 's' : '') + ' &times; ' + formatPrice(unit) + ' = <strong>' + formatPrice(qty * unit) + '</strong>';
      el.style.display = 'block';
    } else {
      el.style.display = 'none';
    }
  }

  function delay(ms) {
    return new Promise(function(resolve) { setTimeout(resolve, ms); });
  }

  function addSingleItem(variantId, qty, size) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({
        items: [{ id: variantId, quantity: qty, properties: { 'Size': size, '_production_time': '7-12 business days' } }]
      })
    }).then(function(res) {
      if (!res.ok) return res.json().then(function(d) { throw new Error(d.description || 'Error adding ' + size); });
      return res.json();
    });
  }

  function injectRemoveButtons(cartDrawer) {
    var items = cartDrawer.querySelectorAll('.cart__item, [data-cart-item], .cart-item');
    items.forEach(function(item) {
      if (item.querySelector('.goce-remove-btn')) return;
      var key = item.getAttribute('data-key');
      var removeBtn = document.createElement('button');
      removeBtn.className = 'goce-remove-btn';
      removeBtn.textContent = 'Remove';
      removeBtn.type = 'button';
      removeBtn.addEventListener('click', function() {
        removeBtn.textContent = 'Removing...';
        removeBtn.disabled = true;
        var body = key
          ? JSON.stringify({ id: key, quantity: 0 })
          : JSON.stringify({ line: Array.from(items).indexOf(item) + 1, quantity: 0 });
        fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: body })
          .then(function() { openCartDrawer(true); })
          .catch(function() { removeBtn.textContent = 'Remove'; removeBtn.disabled = false; });
      });
      var priceEl = item.querySelector('.cart__item-price, .price, [class*="price"]');
      if (priceEl) priceEl.parentNode.insertBefore(removeBtn, priceEl.nextSibling);
      else item.appendChild(removeBtn);
    });
  }

  function openCartDrawer(skipOpen) {
    var cartDrawer = document.querySelector('cart-drawer#cart-drawer');
    if (!cartDrawer) return;
    cartDrawer.classList.remove('is-empty');
    fetch('/?section_id=cart-drawer')
      .then(function(r) { return r.text(); })
      .then(function(html) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
        var newDrawer = doc.querySelector('cart-drawer#cart-drawer');
        if (newDrawer) {
          cartDrawer.innerHTML = newDrawer.innerHTML;
          cartDrawer.classList.remove('is-empty');
        }
        setTimeout(function() { injectRemoveButtons(cartDrawer); }, 300);
        if (!skipOpen) {
          if (typeof cartDrawer.openCartDrawerOnProductAdded === 'function') cartDrawer.openCartDrawerOnProductAdded();
          else if (typeof cartDrawer.openCartDrawer === 'function') cartDrawer.openCartDrawer();
        }
      });
  }

  async function handleAddToCart() {
    var btn = document.getElementById('goce-add-to-cart');
    var errEl = document.getElementById('gsm-error');
    errEl.style.display = 'none';
    var sizeQtys = getSizeQuantities();
    if (sizeQtys.length === 0) {
      errEl.textContent = 'Please enter at least 1 item before adding to cart.';
      errEl.style.display = 'block';
      return;
    }
    var variantId = getVariantId(getSelectedOption('Color'), getSelectedOption('Print Option'));
    if (!variantId) {
      errEl.textContent = 'Could not find the selected variant. Please try again.';
      errEl.style.display = 'block';
      return;
    }
    btn.disabled = true;
    try {
      for (var i = 0; i < sizeQtys.length; i++) {
        var entry = sizeQtys[i];
        btn.textContent = 'Adding ' + entry.size + '... (' + (i + 1) + '/' + sizeQtys.length + ')';
        await addSingleItem(variantId, entry.qty, entry.size);
        if (i < sizeQtys.length - 1) await delay(800);
      }
      btn.textContent = 'Opening cart...';
      await delay(1200);
      document.querySelectorAll('#goce-size-matrix .gsm-qty').forEach(function(i) { i.value = '0'; });
      updateSummary();
      openCartDrawer(false);
    } catch (err) {
      errEl.textContent = err.message || 'Error adding to cart. Please try again.';
      errEl.style.display = 'block';
    } finally {
      btn.disabled = false;
      btn.textContent = 'ADD TO CART';
    }
  }

  function buildMatrix(insertAfter) {
    if (document.getElementById('goce-size-matrix')) return;
    collapseNativeButtonsBlock(insertAfter);

    var matrix = document.createElement('div');
    matrix.id = 'goce-size-matrix';

    var sizeCells = getSizes().map(function (size) {
      return '<div class="gsm-cell">'
        + '<span class="gsm-size-name">' + size + '</span>'
        + '<input type="number" class="gsm-qty" data-size="' + size + '" min="0" value="0" step="1" inputmode="numeric" aria-label="Qty ' + size + '"/>'
        + '</div>';
    }).join('');

    matrix.innerHTML = '<style>'
      + '#goce-size-matrix{margin:8px 0 4px;font-family:inherit}'
      + '.gsm-label{font-size:13px;font-weight:500;margin-bottom:10px;text-transform:uppercase;letter-spacing:.05em}'
      + '.gsm-grid{display:flex;flex-wrap:wrap;gap:8px;margin-bottom:8px}'
      + '.gsm-cell{display:flex;flex-direction:column;align-items:center;gap:4px;min-width:56px}'
      + '.gsm-size-name{font-size:12px;font-weight:500;text-transform:uppercase}'
      + '.gsm-qty{width:56px;height:40px;text-align:center;border:1px solid #ccc;border-radius:4px;font-size:15px;padding:0 4px;background:transparent;color:inherit;-moz-appearance:textfield}'
      + '.gsm-qty::-webkit-outer-spin-button,.gsm-qty::-webkit-inner-spin-button{-webkit-appearance:none}'
      + '.gsm-qty:focus{outline:2px solid #000;border-color:#000}'
      + '#gsm-price-summary{font-size:14px;color:inherit;margin:6px 0 10px;display:none}'
      + '#gsm-error{font-size:13px;color:#c00;margin:6px 0 8px;display:none}'
      + '#goce-add-to-cart{width:100%;padding:14px;background:#000;color:#fff;border:none;border-radius:4px;font-size:15px;font-weight:500;cursor:pointer;letter-spacing:.05em;margin-bottom:12px;transition:background .2s}'
      + '#goce-add-to-cart:hover{background:#222}'
      + '#goce-add-to-cart:disabled{background:#555;cursor:not-allowed}'
      + '#goce-production-notice{display:flex;align-items:flex-start;gap:8px;background:#FFF8EC;border:1px solid #F5C97A;border-radius:6px;padding:10px 14px;margin-bottom:8px;font-size:13px;color:#7A4F00;line-height:1.5}'
      + '#goce-production-notice svg{flex-shrink:0;margin-top:2px}'
      + '#goce-production-notice strong{display:block;font-weight:600;margin-bottom:2px;color:#5C3800}'
      + '@media(max-width:480px){.gsm-grid{gap:6px}.gsm-qty{width:48px;font-size:14px}.gsm-cell{min-width:48px}}'
      + '</style>'
      + '<p class="gsm-label">Quantity per size</p>'
      + '<div class="gsm-grid">' + sizeCells + '</div>'
      + '<p id="gsm-price-summary"></p>'
      + '<p id="gsm-error"></p>'
      + '<button id="goce-add-to-cart" type="button">ADD TO CART</button>'
      + '<div id="goce-production-notice">'
      + '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#F5A623" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>'
      + '<div><strong>Custom order — 7 to 12 business days production time</strong>This item is made to order. Please allow 7–12 business days for production + shipping time.</div>'
      + '</div>';

    insertAfter.parentNode.insertBefore(matrix, insertAfter.nextSibling);

    matrix.querySelectorAll('.gsm-qty').forEach(function (input) {
      input.addEventListener('input', function () {
        updateSummary();
        var errEl = document.getElementById('gsm-error');
        if (errEl) errEl.style.display = 'none';
      });
    });

    document.addEventListener('variant:changed', updateSummary);
    document.getElementById('goce-add-to-cart').addEventListener('click', handleAddToCart);
  }

  function waitForCustomily(block, attempt) {
    attempt = attempt || 0;
    var maxAttempts = 0;

    var customilyField = document.querySelector('input[name*="Upload"], [class*="customily"]');

    if (customilyField || attempt >= maxAttempts) {
      buildMatrix(block);
    } else {
      setTimeout(function() {
        waitForCustomily(block, attempt + 1);
      }, 250);
    }
  }

  function init() {
    if (!document.querySelector('[data-section-type="product"]') &&
        !document.body.classList.contains('template-product')) return;
    if (!isCustomOrderProduct()) return;

    hideNativeUI();

    waitForElement('.product__block--buttons', function (block) {
      waitForCustomily(block, 0);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();